import XAPPService from "app/Core/services/XAPPService";
import _ from "lodash";

export const CUSTOMFIELDS_SALVAR = "[CUSTOMFIELDS APP] SALVAR";
export const CUSTOMFIELDS_GET = "[CUSTOMFIELDS APP] GET FIELDS";
export const CUSTOMFIELDS_WARNING = "[CUSTOMFIELDS APP] WARNING";
export const CUSTOMFIELDS_INFO = "[CUSTOMFIELDS APP] INFO";
export const CUSTOMFIELDS_ERROR = "[CUSTOMFIELDS APP] ERROR";

export function get(_ATipo, _AParams) {
    return (dispatch) => {
        var AActions = [];
        var AConditionAND = [{ "Campo": "tipo", "Operador": "=", "Valor": _ATipo }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "CustomFields", AActions, "spvwcamposcustomizados", ["*"], "SELECIONAR", AConditionAND, []);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) => {
                if (response.data && response.data.length > 0 && !_.isNull(JSON.parse(response.data)[0].data)) {
                    let AValue = JSON.parse(response.data)[0].data[0];
                    dispatch({
                        type: CUSTOMFIELDS_GET,
                        tipo: _ATipo,
                        payload: { ...AValue.formulario, idcamposcustomizados: AValue.idcamposcustomizados },
                    });
                }
            })
            .catch(error => {
                return dispatch({
                    type: CUSTOMFIELDS_ERROR,
                    payload: error
                });
            });
    };
}


export function save(_AValue, _AParams, _ATipo) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AActions = [];
        var AAction = "INSERIR";
        let listCampos = ["tipo", "formulario", "idpessoa"];
        let AValue = {
            "idpessoa": _AParams.empresa,
            "tipo": _ATipo,
            "formulario": _AValue
        };

        if (_AValue.idcamposcustomizados) {
            AAction = "ATUALIZAR";
            AConditionsAND = [{ "Campo": "idcamposcustomizados", "Operador": "=", "Valor": _AValue.idcamposcustomizados }];
        }

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "camposcustomizados", AAction, AValue, "idcamposcustomizados", AConditionsAND, [], 1, listCampos);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    dispatch({
                        type: CUSTOMFIELDS_WARNING,
                        payload: response.warning
                    });
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: CUSTOMFIELDS_INFO,
                            payload: response.info
                        }),
                        dispatch(clearReducer(_ATipo)),
                        dispatch(get(_ATipo, _AParams))
                    ]);
                }
            }).catch(error => {
                return dispatch({
                    type: CUSTOMFIELDS_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer(_ATipo = "all") {
    return {
        type: CUSTOMFIELDS_GET,
        tipo: _ATipo,
        payload: null
    };
}